import { useContext } from 'react';
import { AccountsTableContext, IAccountsTableContext } from './AccountsTableContext';

export const useAccountsTable = () => useContext<IAccountsTableContext>(AccountsTableContext);
